import { useState } from "react";

const ReviewPhotoPreview = ({ thumbnailValue, alt, missing, loading }) => {
	const [showingFullPhoto, setShowingFullPhoto] = useState(false);

	if (missing) {
		return (
			<div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-md bg-stone-100 text-stone-500">
				<span className="text-lg font-bold leading-none">X</span>
				<span className="text-[10px]">Deleted</span>
			</div>
		);
	}

	if (loading || !thumbnailValue) {
		return <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-md bg-stone-100 text-center text-[10px] text-stone-500">Loading</div>;
	}

	return (
		<>
			<button
				type="button"
				className="h-16 w-16 shrink-0 overflow-hidden rounded-md bg-stone-100"
				aria-label="Show full photo"
				onClick={() => setShowingFullPhoto(true)}>
				<img src={thumbnailValue} alt={alt || ""} className="h-full w-full object-cover" />
			</button>
			{showingFullPhoto ? (
				<div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-6" onClick={() => setShowingFullPhoto(false)}>
					<img src={thumbnailValue} alt={alt || ""} className="max-h-full max-w-full object-contain" onClick={(clickEvent) => clickEvent.stopPropagation()} />
				</div>
			) : null}
		</>
	);
};

export default ReviewPhotoPreview;
